var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      staticClass:
        "absolute top-0 left-0 w-full z-10 bg-blue-700 md:flex-row md:flex-nowrap md:justify-start flex items-center p-4"
    },
    [
      _c(
        "div",
        {
          staticClass:
            "w-full mx-autp items-center flex justify-between md:flex-nowrap flex-wrap md:px-10 px-4"
        },
        [
          _c(
            "a",
            {
              staticClass:
                "text-white text-sm uppercase hidden lg:inline-block font-semibold",
              attrs: { href: "javascript:void(0)" }
            },
            [_vm._v("\n      MusicVerse Dashboard\n    ")]
          ),
          _vm._v(" "),
          _c(
            "ul",
            {
              staticClass:
                "flex-col md:flex-row list-none items-center hidden md:flex"
            },
            [_c("user-dropdown")],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4926cc32", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4926cc32","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/Header.vue
// module id = null
// module chunks = 